import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FieldErrorMessage from "../FieldErrorMessage";
export const ButtonGroupContext = React.createContext(undefined);
const ButtonGroup = (props) => {
    const context = {
        name: props.name,
    };
    return (_jsxs("div", { className: "form-group", children: [_jsx("label", { className: "button-group-label", children: props.label }), _jsx("div", { className: "btn-group btn-group-toggle", children: _jsx(ButtonGroupContext.Provider, { value: context, children: props.children }) }), _jsx(FieldErrorMessage, { errorName: props.name })] }));
};
export default ButtonGroup;
